<template>
  <div class="bpmn-help-simple">
    <div class="help-card">
      <div class="help-card__icon">📖</div>
      <div class="help-card__content">
        <div class="help-card__title">Руководство разработчика BPMN</div>
        <div class="help-card__desc">
          Полная инструкция: как добавить новое событие, тип документа, роль, тип задачи,
          авто-действие, новую схему. Карта вызовов <code>handle_event</code> и FAQ.
        </div>
        <a class="help-download-btn" href="/BPMN_DEV_GUIDE.md" download="BPMN_DEV_GUIDE.md">
          ⬇ Скачать BPMN_DEV_GUIDE.md
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bpmn-help-simple {
  padding: 40px 0;
  display: flex;
  justify-content: center;
}
.help-card {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  background: #f5f9ff;
  border: 1px solid #90caf9;
  border-radius: 12px;
  padding: 28px 32px;
  max-width: 520px;
}
.help-card__icon { font-size: 40px; line-height: 1; }
.help-card__content { display: flex; flex-direction: column; gap: 10px; }
.help-card__title { font-size: 16px; font-weight: 700; color: #1565c0; }
.help-card__desc { font-size: 13px; color: #546e7a; line-height: 1.6; }
.help-card__desc code {
  background: #e3f2fd; color: #1565c0;
  padding: 1px 5px; border-radius: 3px; font-size: 12px;
}
.help-download-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #1976d2;
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  width: fit-content;
  transition: background 0.2s;
}
.help-download-btn:hover { background: #1565c0; }
</style>
